import cx from 'classnames';
import { CatListItem } from '@blocks-react/components/ListItem';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconSuccessFilled } from '@blocks-react/components/Icons/SuccessFilled';
import { TextHighlight } from '../../../common';
import { EquipmentLabel } from '../../my-equipment-virtual-scroll-list/equipment-label';
import { getFamilyName } from '../../my-equipment-search-results/utils';
import { getProductFamily } from '../../utils';
import { MyEquipmentListItemProps } from '../../types';
import { EQUIPMENT_LIST_IMAGE_PARAMS } from '../../constants';
import styles from '../../MyEquipment.module.scss';

export const MyEquipmentListItem = ({
  item,
  selectedEquipment,
  onEquipmentSelect,
  searchTerm,
  isVirtualScroll = false,
  elementKey,
  children,
  gapForScroll = ''
}: MyEquipmentListItemProps) => {
  const equipmentFamily = item.productFamily ?? item.equipmentFamily ?? '';
  const familyName = getFamilyName(
    item.model,
    item.name ?? item.equipmentFamily
  );
  const equipmentName = `${item.model} ${getProductFamily(familyName ?? '')}`;
  const nickName = item.assetName ?? item.assetId ?? '';
  const serialNumber = item.serialNumber ?? '';
  const { uniqueIndex } = item;
  const isSelected = uniqueIndex === selectedEquipment?.uniqueIndex;
  const headingVariant = nickName ? 'footnote' : 'display-sm';

  return (
    <CatListItem
      key={elementKey}
      value={`${item.model} ${equipmentFamily}`}
      onClick={() => onEquipmentSelect(item)}
      className={cx(
        `${styles['cat-c-listItems']} mt-3 position-relative`,
        isSelected ? styles['selected-equipment'] : styles['equipment-border'],
        {
          [gapForScroll]: isVirtualScroll
        }
      )}
    >
      {children?.(item) ?? null}
      {isSelected && (
        <CatIconSuccessFilled
          className={`${styles['selected-equipment-icon']} position-absolute`}
          data-testid="selected-equipment-icon"
        />
      )}
      <div className="d-flex">
        <img
          src={
            item.imageURL && `${item.imageURL}${EQUIPMENT_LIST_IMAGE_PARAMS}`
          }
          alt={`${item.model} ${equipmentFamily}`}
          className={`${styles['img--border']}`}
          loading="lazy"
        />
        <div
          className={`ps-2 pe-5 align-content-around ${styles['equipment-list']}`}
        >
          <div>
            {nickName && (
              <EquipmentLabel
                label={nickName}
                searchTerm={searchTerm}
                isVirtualScroll={isVirtualScroll}
              />
            )}
          </div>
          <div>
            {equipmentName && (
              <EquipmentLabel
                label={equipmentName}
                searchTerm={searchTerm}
                variant={headingVariant}
                isVirtualScroll={isVirtualScroll}
              />
            )}
          </div>
          <CatHeading variant="footnote">
            <TextHighlight
              text={serialNumber}
              textToHighlight={searchTerm}
              isSpecialCharacters
              highlightClassName="text-truncate color-black d-block m-0"
            />
          </CatHeading>
        </div>
      </div>
    </CatListItem>
  );
};
